

























import Analytics from '@/services/Analytics'
import Setting from '@/types/Setting.interface'
import { randomKey } from '@/utility/helpers'
import Vue from 'vue'
export default Vue.extend({
    data() {
        return {
            loading: false,
            toolbar: {
                title: 'Signature Message',
                help: {
                    title: 'Signature Message',
                    body: "The Signature is a message snippet that is auto-inserted at the end of every message sent out of MessageDesk. It's a great way for teams to personalize their messages and automatically include important information.",
                    button: {
                        text: 'Learn More',
                        link: `${process.env.VUE_APP_URL_LEARN}/en/articles/6060617-using-text-message-signatures`
                    }
                },
                left: [
                    {
                        title: 'Back',
                        icon: 'mdi-chevron-left',
                        back: '/settings',
                        tooltip: 'Back',
                        permission: 0,
                        feature: null
                    }
                ],
                right: []
            },
            learnMoreLink: `<a target="_blank" href="https://learn.messagedesk.com/en/articles/4527080-how-messagedesk-manages-opt-in-and-opt-out-for-tcpa-compliance">Learn More</a>`,
            signatureKey: randomKey(),
            tempSignature: null
        }
    },
    async mounted() {
        //  If consent is already loaded, clone it
        if (this.signature) this.cloneSignatureMessage()
    },
    computed: {
        signature(): Setting {
            return this.$store.getters.signature
        },
        signatureEnabled(): boolean {
            return this.$store.getters.getEnabled('signature')
        },
        modified(): boolean {
            //  Returns bool, true if either of the opt in or opt out messages have been changed
            return this.tempSignature != this.signature.data
        },
        responsiveStyle(): string {
            return this.$vuetify.breakpoint.xsOnly ? 'min-width:95%;' : 'min-width:500px;'
        }
    },
    methods: {
        cloneSignatureMessage(): void {
            //  Set a temp variable for the current opt in message changes
            this.tempSignature = this.signature.data

            //  Update our key so the form reflects the changes
            this.signatureKey = randomKey()
        },
        popAppendHelp(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Append to All',
                text: 'This setting determines if the signature is applied to all messages.\n\n<b>Enable</b> this setting if you want the signature appended to every text message.\n\n<b>Disable</b> this setting if you do NOT want a signature appended to every message.',
                icon: 'bi-chat-right-quote-fill',
                color: 'primary'
            })
        },
        popSignaturesDisabled(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'FEATURE',
                paywall_type: 'access',
                metadata: 'signature_enabled'
            })
        },
        popInvalidSignature(): void {
            this.$store.commit('appNotificationBarSet', {
                message: 'Cannot Save Empty Message Signature',
                type: 'error'
            })
        },
        popSignatureHelp(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Signature Message',
                text: "The Signature is a message snippet that is auto-inserted at the end of every message sent out of MessageDesk. It's a great way for teams to personalize their messages and automatically include important information.",
                icon: 'bi-pen-fill',
                color: 'primary'
            })
        },
        async updateSignatureMessage(): Promise<void> {
            //  Check if signatures are enabled and if not, pop a dialog
            if (!this.signatureEnabled) return this.popSignaturesDisabled()

            //  Validate the signature message
            const valid = await this.$validator.validateAll()

            //  If not valid, return
            if (!valid) return

            // If user attempts to save a blank message signature we pop warning letting them know this isn't allowed
            if (!this.tempSignature) return this.popInvalidSignature()

            //  Make sure we double encode any newline characters
            const text = this.tempSignature.replace('\n', '\\n')

            //  Create payload
            const payload = { ...this.signature, data: text }

            //  Start the loading spinner
            this.loading = true

            //  Dispatch api request to save the message signature
            const signature = await this.$store.dispatch('settingsPut', payload)

            //  Stop the loading spinner
            this.loading = false

            //  If request failed, return
            if (!signature) return

            //  Confirmation app notification bar
            this.$store.commit('appNotificationBarSet', {
                message: 'Signature Message Updated.'
            })
        },
        async updateSignatureSettings(bool: boolean): Promise<void> {
            //  Check if signatures are enabled and if not, pop a dialog
            if (!this.signatureEnabled) {
                //  Revert the modal
                this.signature.enabled = !bool

                //  Pop our dialog
                return this.popSignaturesDisabled()
            }

            //  We want our signature setting EXCEPT data
            const stripped = window._.pick(this.signature, ['id', 'name', 'enabled'])

            //  Assemble the API payload
            const payload = { ...stripped, enabled: bool }

            //  Start the loading spinner
            this.loading = true

            // Send event to Segment when message signature is toggled on
            if (bool) {
                Analytics.track('MessageSignatureOn')
            }

            //  Send the changes to the server
            await this.$store.dispatch('settingsPut', payload)

            //  Stop the loading spinner
            this.loading = false
        }
    },
    watch: {
        signature(): void {
            this.cloneSignatureMessage()
        }
    }
})
